import { Component, OnDestroy, OnInit } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

import { ApplicationFacade } from '@ridango/components';

import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'rwidget-terms',
    templateUrl: './terms.component.html',
})
export class TermsComponent implements OnInit, OnDestroy {
    private componentDestroyed$ = new Subject<void>();

    highContast$: Observable<boolean> = this.applicationFacade.highContrast$;
    termsUrl$ = this.applicationFacade.termsUrl$;
    termsUrl: SafeUrl;

    constructor(
        private applicationFacade: ApplicationFacade,
        public sanitizer: DomSanitizer,
    ) {}

    ngOnInit() {
        this.applicationFacade.termsUrl$
            .pipe(takeUntil(this.componentDestroyed$))
            .subscribe((url) => (this.termsUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url)));
    }

    ngOnDestroy() {
        this.componentDestroyed$.next();
        this.componentDestroyed$.complete();
    }
}
